import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import OurStoryPageStyle from "./our-story-page.module.scss"

const SteveImg = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "steve.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img className={OurStoryPageStyle.steveImg} fluid={data.placeholderImage.childImageSharp.fluid} />
}

export default SteveImg
